/**
 * Generate a base axios configuration
 * @param {object} params - Request paramaters
 */
const setBaseRequest = (params = {}, cancelToken = null) => ({
	headers: { Accept: 'application/json' },
	timeout: 120000,
	// either of these statuses will resolve the promise. Axios by default rejects on 404
	validateStatus: status => status === 200 || status === 404,
	params,
	cancelToken,
});

export default setBaseRequest;
